import { List } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  padding: {
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(2, 0),
    },
    padding: theme.spacing(1, 0),
  },
}));

type NavigationProps = React.PropsWithChildren<unknown>;

export default function Navigation({ children }: NavigationProps): JSX.Element {
  const classes = useStyles();

  return (
    <List
      className={classes.root}
      classes={{ padding: classes.padding }}
      component="nav"
      dense
    >
      {children}
    </List>
  );
}
